// Libs
import React from 'react';

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<mask
			id='maskCheckSmallIcon'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='1'
			y='4'
			width='13'
			height='10'
		>
			<path
				d='M5.50117 11.5011L2.72117 8.72112L1.77783 9.66446L5.50117 13.3878L13.5012 5.38779L12.5578 4.44446L5.50117 11.5011Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#maskCheckSmallIcon)'>
			<rect width='16' height='16' fill={fill} fillOpacity={fillOpacity} />
		</g>
	</svg>
);
